import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  Card, Container, Grid, Page,
} from 'tabler-react';
import { flatten } from 'lodash';
import ItemTable from '../components/ItemTable';

const userKeywordAlert = gql`
query userKeywordAlert($alertId: ID!) {
  userKeywordAlert(alertId: $alertId) {
    keywords {
      name
      id
      items {
        imageUrl
        id
        endsAt
        descriptionData {
          condition
          description
          msrp
        }
        location
        highBidderId
        lastHighBid
        itemUrl
      }
    }
  }
}
`;

const UserKeywordAlert = ({ response }) => (
  <Container>
    <Page.Header>
      <Page.Title>
          Keyword Alert Email
      </Page.Title>
    </Page.Header>
    <Grid.Row>
      <Grid.Col lg={10}>
        <Card>
          <Query query={userKeywordAlert} variables={{ alertId: response.params.id }}>
            {({ loading, error, data }) => {
              if (loading) {
                return 'Loading...';
              }
              if (error) {
                return error.toString();
              }
              return (
                <ItemTable
                  items={flatten(data.userKeywordAlert.keywords.map((({ items }) => items)))}
                  firstPage
                  lastPage
                  onClick={({ itemUrl }) => window.open(itemUrl, '_blank')}
                />
              );
            }}
          </Query>
        </Card>
      </Grid.Col>
    </Grid.Row>
  </Container>

);

export default UserKeywordAlert;



// WEBPACK FOOTER //
// ./src/keywordAlert/index.js